// extracted by mini-css-extract-plugin
export default {"header-profile":"header_header-profile__fD5yu"};